import React from 'react';
import { getChildrenText } from '../utils/getChildrenText';
var AKBadge = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.badge' */
  '@atlaskit/badge');
});
export var Badge = function Badge(_ref) {
  var _ref$forgeDoc = _ref.forgeDoc,
    props = _ref$forgeDoc.props,
    children = _ref$forgeDoc.children;
  // `text` prop should eventually be deprecated
  // It exists because it was included in Preview
  // Merging the two types here to avoid breaking changes
  var _ref2 = props,
    appearance = _ref2.appearance,
    text = _ref2.text;
  return /*#__PURE__*/React.createElement(AKBadge, {
    appearance: appearance
  }, text ? text : getChildrenText(children));
};